//Listen for cart actions - send Relewise tracking + set line item properties for drawer upsell
(function () {
    if (!window || !window.Shopify) return;
  
    const CartEvents = {
      add: "SCE:add",
      update: "SCE:update",
      change: "SCE:change",
      clear: "SCE:clear",
      mutate: "SCE:mutate",
    };
  
    const ShopifyCartURLs = [
      "/cart/add",
      "/cart/update",
      "/cart/change",
      "/cart/clear",
      "/cart/add.js",
      "/cart/update.js",
      "/cart/change.js",
      "/cart/clear.js",
    ];

    // Generate or get existing session ID for drawer session tracking
    let drawerSessionId = sessionStorage.getItem('drawer_session_id');
    if (!drawerSessionId) {
      drawerSessionId = 'ds_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      sessionStorage.setItem('drawer_session_id', drawerSessionId);
    }

    // Track SKUs that were added through drawer upsell
    let drawerUpsellTracker = new Set();
  
    function isShopifyCartURL(url) {
      if (!url) return false;
      const path = url.split("/").pop();
      return ShopifyCartURLs.includes(`/cart/${path}`);
    }
  
    function updateType(url) {
      if (!url) return false;
      if (url.includes("cart/add")) {
        return "add";
      } else if (url.includes("cart/update")) {
        return "update";
      } else if (url.includes("cart/change")) {
        return "change";
      } else if (url.includes("cart/clear")) {
        return "clear";
      } else return false;
    }
  
    function dispatchEvent(url, detail) {
      if (typeof detail === "string") {
        try {
          detail = JSON.parse(detail);
        } catch {}
      }

      window.dispatchEvent(new CustomEvent(CartEvents.mutate, { detail }));
      const type = updateType(url);
      switch (type) {
        case "add":
          window.dispatchEvent(new CustomEvent(CartEvents.add, { detail }));
          break;
        case "update":
          window.dispatchEvent(new CustomEvent(CartEvents.update, { detail }));
          break;
        case "change":
          window.dispatchEvent(new CustomEvent(CartEvents.change, { detail }));
          break;
        case "clear":
          window.dispatchEvent(new CustomEvent(CartEvents.clear, { detail }));
          break;
        default:
          break;
      }
    }

    // Function to check if product was added from drawer recommendations
    function isDrawerUpsellContext() {
      const cartDrawer = document.querySelector('cart-drawer');
      return cartDrawer && (cartDrawer.hasAttribute('open') || cartDrawer.classList.contains('is-open') || cartDrawer.open === true);
    }

    // Function to clean price text and extract just the numerical value
    function cleanPriceText(priceElement) {
      if (!priceElement) return '';
      
      // Clone the element to avoid modifying the original
      const clone = priceElement.cloneNode(true);
      
      // Remove screen reader text (sr-only elements)
      const srOnlyElements = clone.querySelectorAll('.sr-only');
      srOnlyElements.forEach(el => el.remove());
      
      // Get the text content and clean it
      let priceText = clone.textContent.trim();
      
      // Remove currency codes and common terms
      priceText = priceText
        .replace(/\s*DKK\s*/g, '') // Remove DKK
        .replace(/\s*EUR\s*/g, '') // Remove EUR  
        .replace(/\s*USD\s*/g, '') // Remove USD
        .replace(/^Fra\s+/i, '')   // Remove "Fra" prefix
        .replace(/^From\s+/i, '')  // Remove "From" prefix
        .trim();
      
      return priceText;
    }

    // Function to get product info from cart drawer recommendations
    function getProductInfoFromDrawer(productId) {
      // Try to find product info from recommendation areas
      const recommendationAreas = [
        '#cart-recommendation-target-1',
        '#cart-recommendation-target-2'
      ];

      for (const areaSelector of recommendationAreas) {
        const area = document.querySelector(areaSelector);
        if (!area) continue;

        const productCards = area.querySelectorAll('.product-card');
        for (const card of productCards) {
          const productHandle = card.getAttribute('handle');
          const productLink = card.querySelector('a[href*="/products/"]');
          
          if (productLink) {
            const href = productLink.getAttribute('href');
            const handleFromUrl = href.split('/products/')[1]?.split('?')[0];
            
            if (handleFromUrl) {
              const titleElement = card.querySelector('.product-title');
              const priceElement = card.querySelector('sale-price');
              
              return {
                handle: handleFromUrl,
                title: titleElement ? titleElement.textContent.trim() : '',
                price: cleanPriceText(priceElement),
                recommendationType: areaSelector.includes('target-1') ? 'sidebar' : 'bottom'
              };
            }
          }
        }
      }
      
      return null;
    }

    // Temporarily disable listeners
    function disableListeners() {
      window.XMLHttpRequest.prototype.open = originalOpen;
      window.fetch = originalFetch;
    }

    // Re-enable listeners
    function enableListeners() {
      fetchOverride();
      XHROverride();
    }

    // Override XMLHttpRequest to listen to cart events
    function XHROverride() {
      if (!window.XMLHttpRequest) return;

      window.XMLHttpRequest.prototype.open = function () {
        const url = arguments[1];
        this.addEventListener("load", function () {
          if (isShopifyCartURL(url)) {
            dispatchEvent(url, this.response);
          }
        });
        return originalOpen.apply(this, arguments);
      };
    }

    // Override fetch to listen to cart events
    function fetchOverride() {
      if (!window.fetch || typeof window.fetch !== "function") return;
      window.fetch = function () {
        const response = originalFetch.apply(this, arguments);

        if (isShopifyCartURL(arguments[0])) {
          response.then((res) => {
            res
              .clone()
              .json()
              .then((data) => {
                dispatchEvent(res.url, data);

                // If this is an add-to-cart action and cart drawer is open, track for upsell
                if (res.url.includes('/cart/add') && isDrawerUpsellContext()) {
                  let skus = [];
                  let variantIds = [];
                  
                  if (Array.isArray(data.items)) {
                    // Multiple items added
                    data.items.forEach(item => {
                      if (item.sku) skus.push(item.sku);
                      if (item.variant_id) variantIds.push(item.variant_id);
                    });
                  } else if (data && data.sku) {
                    // Single item added
                    skus = [data.sku];
                    variantIds = [data.variant_id || data.id];
                  }

                  // Track these SKUs as drawer upsell products
                  skus.forEach(sku => {
                    if (sku) drawerUpsellTracker.add(sku);
                  });

                  console.log('Drawer upsell products tracked:', Array.from(drawerUpsellTracker));
                }
              });
          });
        }

        return response;
      };
    }

    // Function to intercept product form submissions from drawer recommendations
    function interceptDrawerUpsellForms() {
      // Use event delegation to handle dynamically added forms
      document.addEventListener('submit', function(event) {
        const form = event.target;
        
        // Check if this is a product form within recommendation areas or quick-buy modal triggered from recommendations
        const isProductForm = form.getAttribute('action') === '/cart/add' || form.closest('[is="product-form"]');
        const recommendationArea = form.closest('#cart-recommendation-target-1, #cart-recommendation-target-2');
        
        // Also check if quick-buy modal was triggered from recommendations
        const quickBuyModal = form.closest('quick-buy-modal');
        let isFromQuickBuyModal = false;
        
        if (quickBuyModal && window.drawerUpsellPending) {
          isFromQuickBuyModal = true;
        }
        
        if (isProductForm && isDrawerUpsellContext() && (recommendationArea || isFromQuickBuyModal)) {
          let productInfo = {
            handle: '',
            title: '',
            price: '',
            recommendationType: 'bottom'
          };

          if (recommendationArea) {
            // Direct form submission from recommendation area
            const productCard = form.closest('.product-card');
            if (productCard) {
              productInfo.handle = productCard.getAttribute('handle') || '';
              const titleElement = productCard.querySelector('.product-title');
              const priceElement = productCard.querySelector('sale-price');
              productInfo.title = titleElement ? titleElement.textContent.trim() : '';
              productInfo.price = cleanPriceText(priceElement);
              productInfo.recommendationType = recommendationArea.id.includes('target-1') ? 'sidebar' : 'bottom';
            }
          } else if (isFromQuickBuyModal && window.drawerUpsellPending) {
            // Quick-buy modal submission
            productInfo = {
              handle: window.drawerUpsellPending.handle,
              title: window.drawerUpsellPending.title,
              price: window.drawerUpsellPending.price,
              recommendationType: window.drawerUpsellPending.recommendationType
            };
            
            // Clear the pending data
            delete window.drawerUpsellPending;
          }

          // Add hidden fields for line item properties
          const hiddenFields = [
            { name: 'properties[_source]', value: 'drawer_upsell' },
            { name: 'properties[_added_at]', value: new Date().toISOString() },
            { name: 'properties[_drawer_session]', value: drawerSessionId },
            { name: 'properties[_product_title]', value: productInfo.title },
            { name: 'properties[_product_handle]', value: productInfo.handle },
            { name: 'properties[_recommendation_type]', value: productInfo.recommendationType },
            { name: 'properties[_price_displayed]', value: productInfo.price }
          ];

          hiddenFields.forEach(field => {
            // Remove any existing field with same name to avoid duplicates
            const existingField = form.querySelector(`input[name="${field.name}"]`);
            if (existingField) {
              existingField.remove();
            }

            // Add new hidden field
            const hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = field.name;
            hiddenInput.value = field.value;
            form.appendChild(hiddenInput);
          });

          console.log('Added drawer upsell properties to form:', productInfo);
        }
      });
    }

    // Function to intercept quick-add button clicks in recommendations
    function interceptQuickAddButtons() {
      document.addEventListener('click', function(event) {
        const button = event.target.closest('.product-card__quick-add-button');
        
        if (button) {
          const recommendationArea = button.closest('#cart-recommendation-target-1, #cart-recommendation-target-2');
          
          if (recommendationArea && isDrawerUpsellContext()) {
            const productCard = button.closest('.product-card');
            
            if (productCard) {
              const productHandle = productCard.getAttribute('handle');
              const titleElement = productCard.querySelector('.product-title');
              const priceElement = productCard.querySelector('sale-price');
              
              // Store this info temporarily for when the form is actually submitted
              window.drawerUpsellPending = {
                handle: productHandle || '',
                title: titleElement ? titleElement.textContent.trim() : '',
                price: cleanPriceText(priceElement),
                recommendationType: recommendationArea.id.includes('target-1') ? 'sidebar' : 'bottom'
              };

              console.log('Quick-add from drawer upsell detected:', window.drawerUpsellPending);
            }
          }
        }
      });
    }

    const originalOpen = window.XMLHttpRequest.prototype.open;
    const originalFetch = window.fetch;

    // Initialize overrides and interceptors
    fetchOverride();
    XHROverride();
    interceptDrawerUpsellForms();
    interceptQuickAddButtons();

    // Clean up old cart attributes on page load (optional migration step)
    window.addEventListener('DOMContentLoaded', function() {
      // You can remove this section after migration is complete
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(response => response.json())
        .then(cart => {
          if (cart.attributes && cart.attributes.DrawerUpsaleProducts) {
            // Clear old attribute
            fetch('/cart/update.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
              body: new URLSearchParams({
                'attributes[DrawerUpsaleProducts]': ''
              }).toString(),
            });
            console.log('Cleared legacy DrawerUpsaleProducts attribute');
          }
        })
        .catch(error => {
          console.error('Error checking cart attributes:', error);
        });
    });

    // Debug function to check current cart and line item properties
    window.debugDrawerUpsellTracking = function() {
      console.log('=== Drawer Upsell Tracking Debug ===');
      console.log('Session ID:', drawerSessionId);
      console.log('Tracked SKUs:', Array.from(drawerUpsellTracker));
      console.log('Pending Quick-Buy:', window.drawerUpsellPending);
      
      // Test price selectors on current recommendations
      const recommendationAreas = ['#cart-recommendation-target-1', '#cart-recommendation-target-2'];
      recommendationAreas.forEach(areaSelector => {
        const area = document.querySelector(areaSelector);
        if (area) {
          const productCards = area.querySelectorAll('.product-card');
          console.log(`${areaSelector} has ${productCards.length} product cards:`);
                     productCards.forEach((card, index) => {
             const title = card.querySelector('.product-title')?.textContent?.trim();
             const priceElement = card.querySelector('sale-price');
             const price = cleanPriceText(priceElement);
             const handle = card.getAttribute('handle');
             console.log(`  Card ${index + 1}: ${title} - ${price} (${handle})`);
           });
        }
      });
      
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(response => response.json())
        .then(cart => {
          console.log('Current Cart:');
          console.log('- Total Items:', cart.items.length);
          
          const upsellItems = cart.items.filter(item => 
            item.properties && item.properties._source === 'drawer_upsell'
          );
          
          console.log('- Drawer Upsell Items:', upsellItems.length);
          
          upsellItems.forEach((item, index) => {
            console.log(`  Item ${index + 1}:`, {
              title: item.title,
              handle: item.properties._product_handle,
              source: item.properties._source,
              addedAt: item.properties._added_at,
              session: item.properties._drawer_session,
              recommendationType: item.properties._recommendation_type,
              priceDisplayed: item.properties._price_displayed
            });
          });
        })
        .catch(error => {
          console.error('Error fetching cart for debug:', error);
        });
    };

    console.log('Drawer Upsell Tracking initialized. Use debugDrawerUpsellTracking() to debug.');

})();
  
  